import { securityData } from "@/mocks/homeData";
import AnimatedSection from "@/components/AnimatedSection";

export default function SecuritySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50 border-y border-background-200/50">
      <div className="container-astro">
        <AnimatedSection>
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-4 font-heading tracking-tight">
              {securityData.heading}
            </h2>
            <div className="w-12 h-1 bg-accent-500 rounded-full mx-auto" />
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-5">
          {securityData.items.map((item, i) => (
            <AnimatedSection key={item.title} delay={i * 80}>
              <div className="group flex items-center gap-3 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-300/25 hover:shadow-sm transition-all duration-300">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600 shrink-0 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className={`${item.icon} text-base`} />
                  </span>
                </div>
                <span className="text-sm font-semibold text-foreground-800 font-heading">
                  {item.title}
                </span>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}